import { useMutation } from '@tanstack/react-query';

import { getFaireVersementJustificatifsValidationUniversign } from '@/services/getFaireVersementJustificatifsValidationUniversign/getFaireVersementJustificatifsValidationUniversign';
import { log } from '@/utils/functions/logger/logger';

export const useFaireVersementJustificatifsValidationUniversign = () => {
  return useMutation({
    mutationFn: getFaireVersementJustificatifsValidationUniversign,
    onError: (error) => {
      log.error(`useFaireVersementJustificatifsValidationUniversign failed: ${error}`);
    },
  });
};
